export default (to, from, next) => next(vm => {
  if (vm.$store.state.registrationFinished) next('finish')
  else next()
})




const stepOneValid = (state) => {
  return !state.gender.isEmpty() && !state.searchGender.isEmpty() && state.searchAgeRange.min && state.searchAgeRange.max
}

const stepTwoValid = (state) => {
  return state.geoId !== -1 && !state.birthdate.isEmpty()
}

export const stepOneGuard = (to, from, next) => next(vm => {
  if ( vm.$store.state.registrationFinished) next('finish')
  else next()
})

export const stepTwoGuard = (to, from, next) => next(vm => {
  const state = vm.$store.state
  if (state.registrationFinished) next('finish')
  else if(!stepOneValid(state)) next("")
  else next()
})


export const stepThreeGuard = (to, from, next) => next(vm => {
  const state = vm.$store.state
  if (state.registrationFinished) next('finish')
  else if(!stepOneValid(state)) next("")
  else if(!stepTwoValid(state)) next("step-two")
  else next()
})
